import React, { useEffect, useRef, useState } from "react";
import Swiper from "swiper";
import "../../../node_modules/swiper/swiper.min.css";
import Head from "next/head";
import striptags from "striptags";
import dynamic from "next/dynamic";

const Loader = dynamic(() => import("../../components/common/Loader/Loader"));
const Layout = dynamic(() => import("../../components/common/Layout/Layout"));
const CommonCtaSection = dynamic(
  () => import("../../components/common/CTASection/CommonCtaSection")
);
const AgileBanner = dynamic(
  () => import("../../components/Industries/AgileBanner")
);
const OutOffer = dynamic(() => import("../../components/Industries/OutOffer"));
const CtaSection = dynamic(
  () => import("../../components/Industries/CtaSection")
);
const Specialities = dynamic(
  () => import("../../components/Industries/Specialities")
);
const Edtech = dynamic(() => import("../../components/Industries/Edtech"));
const IndustrySolutions = dynamic(
  () => import("../../components/Industries/IndustrySolutions")
);
const FaqSection = dynamic(
  () => import("../../components/Service/FaqSection")
);

const OverviewSection = dynamic(
  () => import("../../components/Service/OverviewSection")
);


const Industries = ({ apiData }) => {
  const swiperRef = useRef(null);
  const industryData = apiData?.detail;
  const [loader, setLoader] = useState(true);
  const title = apiData?.page_title;
  const seo_title = apiData?.meta?.seo_title;
  const canonicalUrl = apiData?.canonical_url;
  const search_description = apiData?.meta?.search_description;
  const og_title = apiData?.og_title;
  const og_description = apiData?.og_description;
  const og_image = apiData?.og_image?.url;
  const structuredData = apiData?.struct_org_extra_json;
  const formatJson = (json) => {
    return {
      __html: `${json}`,
    };
  }
  const [showAllFaqs, setShowAllFaqs] = useState(true);
  const [activeItem, setActiveItem] = useState(0);


  useEffect(() => {
    let testimonialsSwiper;

    const initSwiper = () => {
      testimonialsSwiper = new Swiper(".swiper-offering", {
        loop: true,
        spaceBetween: 30,
        slidesPerView: 1.2,
        autoplay: {
          delay: 2500,
          disableOnInteraction: true,
        },
        speed: 2000,
        grabCursor: true,
        navigation: {
          nextEl: ".swiper-next", // Use Swiper's built-in navigation controls
          prevEl: ".swiper-prev", // Use Swiper's built-in navigation controls
        },
        breakpoints: {
          1920: {
            slidesPerView: 3,
          },
          991: {
            slidesPerView: 3,
          },
          767: {
            slidesPerView: 2,
          },
        },
      });
    };

    initSwiper();
    swiperRef.current = testimonialsSwiper;

    return () => {
      if (testimonialsSwiper) {
        // testimonialsSwiper.destroy();
      }
    };
  }, []);

  useEffect(() => {
    setLoader(false);
  }, [industryData]);

  return (
    <>
      <Head>
        <title>{striptags(title)} </title>

        <meta name="title" content={seo_title} key="og-title" />

        <meta name="description" content={search_description} key="og-desc" />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={og_title || seo_title} />
        <meta property="og:description" content={og_description || search_description} />
        <meta property="og:image" content={og_image} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Quixom" />
        {structuredData && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={formatJson(structuredData)}
          />
        )}

      </Head>
      <Layout>
        {loader && <Loader />}
        <main className="main-wrapper industries-page-middle">
          <article className="wrapper-inner">
            {industryData?.map((val, index) => {
              switch (val?.type) {
                case "industry_banner":
                  return <AgileBanner key={index} industryData={val} />;
                case "offering":
                  return <OutOffer key={index} industryData={val} />;
                case "cta_gradient":
                  return <CtaSection key={index} industryData={val} />;
                case "specialities":
                  return <Specialities key={index} industryData={val} />;
                case "game":
                  return <Edtech key={index} industryData={val} />;
                case "solutions":
                  return <IndustrySolutions key={index} industryData={val} />;
                // case "service_overview":
                //   return (
                //     <OverviewSection key={index} serviceDetail={industryData} />
                //   );
                // case "counter_section":
                //   return (
                //     <CounterSection key={index} serviceDetail={industryData} />
                //   );
                // case "hire_process":
                //   return (
                //     <HireProcess key={index} serviceDetail={industryData} />
                //   );
                // case "data_analytics_section":
                //   return (
                //     <DataAnalytics key={index} serviceDetail={industryData} />
                //   );
                // case "analytics_and_infrastructure":
                //   return (
                //     <AnalyticsAndInfraStructure
                //       key={index}
                //       serviceDetail={industryData}
                //     />
                //   );
                // case "ai_section":
                //   return (
                //     <ArtificialIntelligence
                //       key={index}
                //       serviceDetail={industryData}
                //       aiShow={true}
                //     />
                //   );
                // case "data_science":
                //   return (
                //     <DataScience key={index} serviceDetail={industryData} />
                //   );
                // case "benefits_services":
                //   return (
                //     <BenefitsService key={index} serviceDetail={industryData} />
                //   );
                // case "choose_us_services":
                //   return <ChooseUS key={index} serviceDetail={industryData} />;
                // case "why_hire":
                //   return <ChooseUS key={index} serviceDetail={industryData} />;
                // case "why_quixom_services":
                //   return <WhyQuixom key={index} serviceDetail={industryData} />;
                // case "framework":
                //   return <FrameWork key={index} serviceDetail={industryData} />;
                // case "develop_app_section":
                //   return (
                //     <DevelopAppSection
                //       key={index}
                //       serviceDetail={industryData}
                //     />
                //   );
                // case "strategic_partnership":
                //   return (
                //     <StrategicPartnership
                //       key={index}
                //       serviceDetail={industryData}
                //     />
                //   );
                // case "technology_use":
                //   return (
                //     <TechnologyUse key={index} serviceDetail={industryData} />
                //   );
                // case "cta_gradient":
                //   return (
                //     <CtaGradient key={index} serviceDetail={industryData} />
                //   );
                // case "specialities":
                //   return (
                //     <OurSpecialities key={index} serviceDetail={industryData} />
                //   );
                // case "work_process":
                //   return (
                //     <WorkProcessSEction
                //       key={index}
                //       serviceDetail={industryData}
                //     />
                //   );
                // case "technology_stack":
                //   return (
                //     <TechnologyStack key={index} serviceDetail={industryData} />
                //   );
                // case "solutions":
                //   return (
                //     <IndustrySolutionSection
                //       key={index}
                //       serviceDetail={industryData}
                //     />
                //   );
                // case "case_studies_block":
                //   return (
                //     <CaseStudyBlock key={index} serviceDetail={industryData} />
                //   );
                // case "offering":
                //   return (
                //     <OurOfferingSection
                //       key={index}
                //       serviceDetail={industryData}
                //     />
                //   );
                // case "faq":
                //   return (
                //     <FaqSection
                //       key={index}
                //       serviceDetail={industryData}
                //       showAllFaqs={showAllFaqs}
                //       activeItem={activeItem}
                //       setShowAllFaqs={() => {
                //         setShowAllFaqs(true);
                //       }}
                //     />
                //   );
                // case "articles":
                //   return (
                //     <ServiceArticle key={index} serviceDetail={industryData} />
                //   );
                case "title_description_paragraph_section":
                  return <OverviewSection key={index} serviceDetail={val} />;
                case "faq":
                  return (
                    <FaqSection
                      key={index}
                      serviceDetail={val}
                      showAllFaqs={showAllFaqs}
                      activeItem={activeItem}
                      setShowAllFaqs={() => {
                        setShowAllFaqs(true);
                      }}
                    />
                  );
                case "cta":
                  return <CommonCtaSection key={index} data={val} />;
                // Add more cases for other section types if needed
                default:
                  return null;
              }
            })}
          </article>
        </main>
      </Layout>
    </>
  );
};

export async function getServerSideProps(context) {
  // Fetch data from your API

  const { query } = context; // Access query parameters directly from the context
  const yourValue = query.slug;

  // const URLs = localStorage.getItem("apiLink");

  const response = await fetch(
    process.env.NEXT_PUBLIC_API_ENDPOINT + `/cms/pages/${yourValue}`,
    { next: { revalidate: 3600 } }
  );
  const apiData = await response.json();

  if (apiData?.redirect_url) {
    return {
      redirect: {
        destination: apiData.redirect_url,
        permanent: false,
      },
    };
  }

  return {
    props: {
      apiData,
    },
  };
}

export default Industries;
